import React from "react";

import UserMessage from "./UserMessage";
import ErrorMessage from "./ErrorMessage";
import LoadingMessage from "./LoadingMessage";
import ReplaceMessage from "./ReplaceMessage";
import { MessageRendererProps } from "./types";
import AssistantMessage from "./AssistantMessage";

const MessageRenderer = React.memo<MessageRendererProps>(
  ({ message, onDismiss, onRetry, onTypingComplete, onTypingProgress }) => {
    switch (message.type) {
      case "assistant":
        return (
          <AssistantMessage
            content={message.content}
            onTypingComplete={
              onTypingComplete ? () => onTypingComplete(message.id) : undefined
            }
            onTypingProgress={onTypingProgress}
            sources={message.sources ? [message.sources] : undefined}
            typing={message.typing}
          />
        );
      case "error":
        return (
          <ErrorMessage
            content={message.content}
            error={message.error!}
            messageId={message.id}
            onDismiss={onDismiss}
            onRetry={onRetry}
          />
        );
      case "loading":
        return <LoadingMessage />;
      case "replace":
        return (
          <ReplaceMessage
            content={message.content}
            onTypingComplete={
              onTypingComplete ? () => onTypingComplete(message.id) : undefined
            }
            onTypingProgress={onTypingProgress}
            typing={message.typing}
          />
        );
      case "user":
        return <UserMessage content={message.content} />;
      default:
        return null;
    }
  }
);

MessageRenderer.displayName = "MessageRenderer";

export default MessageRenderer;
